<h1>My Profile</h1>
<ciao-guest-badge
  class="profile-guest-badge"
  [personId]="personId"
  variant="profile"
></ciao-guest-badge>
<form class="profile-form">
  <div class="row">
    <ciao-form-field
      label="First Name"
      [formControlInput]="formGroup.get('person.firstName')"
    ></ciao-form-field>
    <ciao-form-field
      label="Last Name"
      [formControlInput]="formGroup.get('person.lastName')"
    ></ciao-form-field>
  </div>

  <div class="row">
    <ciao-form-field
      label="Admin Roles"
      placeholder="No Roles Selected"
      [formControlInput]="formGroup.get('regionRoles')"
      [type]="'multiselect'"
      [selectOptions$]="AssignRegionRoleSelectOptions$"
      [compareWith]="AssignRegionRoleCompare"
      [customTrigger]="AssignRegionRoleCustomTriggerText"
    ></ciao-form-field>
    <ciao-form-field
      label="Default Supervisor"
      [formControlInput]="formGroup.get('defaultSupervisorId')"
      [toolTip]="infoText.defaultSupervisor"
      type="combobox"
      [selectOptions$]="defaultSupervisorSelectOptions$"
    ></ciao-form-field>
  </div>
</form>
<hr />
<h1>My Contact Info</h1>
<form class="contact-form">
  <h2 class="fullwidth">Email Addresses for Authentication <span>*</span></h2>
  <p class="fullwidth">
    A valid email is required usa a .GOV email for government device logins and
    your personal Login.gov email for personal device logins.
  </p>
  <fieldset>
    <ciao-form-field
      label="Primary Email"
      [formControlInput]="formGroup.get('users.0.email')"
    ></ciao-form-field>
    <div *ngIf="isGovEmail(0) && !isEmailVerified(0)" class="email-verification-warning">
      <mat-icon>warning</mat-icon>
      <span>This .gov email is unverified. Check your inbox for a verification link.</span>
      <button
        class="btn-link"
        [disabled]="isResending[0]"
        (click)="resendVerification(0)"
      >
        {{ isResending[0] ? 'Sending...' : 'Resend' }}
      </button>
    </div>
    <div *ngIf="isGovEmail(0) && isEmailVerified(0)" class="email-verification-success">
      <mat-icon>check_circle</mat-icon>
      <span>Verified</span>
    </div>
    <div class="indent email-notifications-group" role="group" aria-label="Primary Email Notifications">
      <div class="email-notifications-label">
        <legend>Select Email Notifications:</legend>
        <ciao-tool-tip
          title="Email Notifications"
          message="When enabled, Crew Members and their Points of Contact will receive email notifications at the start and/or end of a trip."
        ></ciao-tool-tip>
      </div>
      <ciao-form-field
        type="checkbox"
        label="Crew Member"
        [formControlInput]="
          formGroup.get('users.0.notificationOptions.defaultSet')
        "
      ></ciao-form-field>
      <ciao-form-field
        type="checkbox"
        label="Point of Contact (POC)"
        [formControlInput]="
          formGroup.get('users.0.notificationOptions.pocSet')
        "
      ></ciao-form-field>
    </div>
  </fieldset>
  <fieldset>
    <ciao-form-field
      label="Secondary Email"
      [formControlInput]="formGroup.get('users.1.email')"
    ></ciao-form-field>
    <div *ngIf="isGovEmail(1) && !isEmailVerified(1)" class="email-verification-warning">
      <mat-icon>warning</mat-icon>
      <span>This .gov email is unverified. Check your inbox for a verification link.</span>
      <button
        class="btn-link"
        [disabled]="isResending[1]"
        (click)="resendVerification(1)"
      >
        {{ isResending[1] ? 'Sending...' : 'Resend' }}
      </button>
    </div>
    <div *ngIf="isGovEmail(1) && isEmailVerified(1)" class="email-verification-success">
      <mat-icon>check_circle</mat-icon>
      <span>Verified</span>
    </div>
    <div class="indent email-notifications-group" role="group" aria-label="Secondary Email Notifications">
      <div class="email-notifications-label">
        <legend>Select Email Notifications:</legend>
        <ciao-tool-tip
          title="Email Notifications"
          message="When enabled, Crew Members and their Points of Contact will receive email notifications at the start and/or end of a trip."
        ></ciao-tool-tip>
      </div>
      <ciao-form-field
        type="checkbox"
        label="Crew Member"
        [formControlInput]="
          formGroup.get('users.1.notificationOptions.defaultSet')
        "
      ></ciao-form-field>
      <ciao-form-field
        type="checkbox"
        label="Point of Contact (POC)"
        [formControlInput]="
          formGroup.get('users.1.notificationOptions.pocSet')
        "
      ></ciao-form-field>
    </div>
  </fieldset>

  <h2 class="fullwidth">My Cell Phone Numbers</h2>
  <fieldset>
    <ciao-form-field
      label="Government Cell Phone"
      [formControlInput]="formGroup.get('governmentPhone.phoneNumber')"
      [toolTip]="infoText.GovernmentDevice"
      type="phoneNumber"
    ></ciao-form-field>
    <div class="indent">
      <mat-radio-group
        name="deafultPhone"
        [formControl]="formGroup.controls.defaultPhone"
      >
        <mat-radio-button
          [value]="'government'"
          [disabled]="disableGovernmentPhoneRadio"
        >
          Default Phone
        </mat-radio-button>
      </mat-radio-group>
      <hr />
      <legend [ngClass]="{ disabled: disableGovernmentPhoneRadio }">
        Select Text Notifications
      </legend>
      <ng-container *ngFor="let option of textNotificationOptions">
        <ciao-form-field
          [label]="option.label"
          [formControlInput]="
            formGroup.get(['governmentPhone', 'smsNotifications', option.key])
          "
          type="checkbox"
        ></ciao-form-field>
      </ng-container>
    </div>
  </fieldset>
  <fieldset>
    <ciao-form-field
      label="Personal Cell Phone"
      [formControlInput]="formGroup.get('personalPhone.phoneNumber')"
      [toolTip]="infoText.Personal"
      type="phoneNumber"
    ></ciao-form-field>
    <div class="indent">
      <mat-radio-group
        name="deafultPhone"
        [formControl]="formGroup.controls.defaultPhone"
      >
        <mat-radio-button
          [value]="'personal'"
          [disabled]="disablePersonalPhoneRadio"
        >
          Default Phone
        </mat-radio-button>
      </mat-radio-group>

      <hr />
      <legend [ngClass]="{ disabled: disablePersonalPhoneRadio }">
        Select Text Notifications
      </legend>
      <ng-container *ngFor="let option of textNotificationOptions">
        <ciao-form-field
          [label]="option.label"
          [formControlInput]="
            formGroup.get(['personalPhone', 'smsNotifications', option.key])
          "
          type="checkbox"
        ></ciao-form-field>
      </ng-container>
    </div>
  </fieldset>
</form>
<form class="profile-form">
  <h2 class="fullwidth">Default Clock Type and Time Zone</h2>
  <p class="fullwidth">
    This setting applies to all text messages and email communications. Your
    selected clock and time zone will not change how times are displayed on trip
    pages.
  </p>
  <div class="row">
    <ciao-form-field
      label="Clock"
      type="dropdown"
      placeholder="Select a clock type..."
      [selectOptions$]="clockHourOptions$"
      [customTrigger]="getCustomTriggerFn(clockHourOptions$ | async)"
      [formControlInput]="formGroup.get('person.configSettings.clock.hour12')"
    ></ciao-form-field>
    <ciao-form-field
      label="Time Zone"
      type="dropdown"
      placeholder="Select Time Zone..."
      [selectOptions$]="timeZoneOptions$"
      [customTrigger]="getCustomTriggerFn(timeZoneOptions$ | async)"
      [formControlInput]="formGroup.get('person.configSettings.clock.timeZone')"
    ></ciao-form-field>
  </div>
</form>
<div class="btn-container">
  <button
    class="btn-action-solid"
    [disabled]="!formGroup.valid || isSaving"
    (click)="updateProfile()"
  >
    Update User Profile
  </button>
</div>
